/** Only optimistic-lock failures are edit conflicts. Preview failures may also
 * use HTTP 409 after the draft was already durably saved. */
export function isVersionConflict(reason: unknown): boolean {
  const error = reason as { status?: number; payload?: { currentVersion?: unknown } } | null;
  return error?.status === 409 && Number.isInteger(error.payload?.currentVersion);
}

export function savedPreviewFailure(version: number): string {
  return `Draft ${version} is saved, but its preview could not finish. Your live site is unchanged. Try Save draft again.`;
}
